import { Stack, Typography } from '@mui/material';
import { dynamicInvoiceProductLineItemSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { FC } from 'react';
import { VyTooltip } from '../../../../../components/new-design/VyTooltip';
import { lineItemHeaderStyles } from './styles';

type LineItemHeaderProps = {
  name: string;
  description?: string | null;
  percentage: number | null;
};

export const LineItemHeader: FC<LineItemHeaderProps> = ({ name, description, percentage }) => {
  return (
    <Stack direction="column" spacing={0.5} sx={lineItemHeaderStyles.container}>
      <Stack direction="row" spacing={1} sx={{
        alignItems: "center"
      }}>
        <VyTooltip tooltipContent={name} placement="top">
          <Typography
            noWrap
            {...getSelectorAttribute(dynamicInvoiceProductLineItemSelectors.name)}
            sx={[{
              textOverflow: "ellipsis"
            }, lineItemHeaderStyles.title]}>
            {name}
          </Typography>
        </VyTooltip>
        {percentage !== null && (
          <Typography sx={lineItemHeaderStyles.percentage}>({percentage}%)</Typography>
        )}
      </Stack>
      {description && (
        <VyTooltip tooltipContent={description} placement="top">
          <Typography
            noWrap
            variant="body2"
            {...getSelectorAttribute(dynamicInvoiceProductLineItemSelectors.period)}
            sx={[{
              textOverflow: "ellipsis"
            }, lineItemHeaderStyles.description]}>
            {description}
          </Typography>
        </VyTooltip>
      )}
    </Stack>
  );
};
